import styled from 'styled-components';

const HiddenAnchor = styled.a`
    display: none;
    position: absolute;
`;

export default HiddenAnchor;
